import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { SITE } from "@/lib/api";

export const Logo = ({ className = "h-24 md:h-32" }) => (
  <motion.div
    initial={{ filter: "blur(10px)", opacity: 0, y: -10 }}
    animate={{ filter: "blur(0px)", opacity: 1, y: 0 }}
    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
    className="pt-10 flex justify-center"
  >
    <Link to="/" data-testid="logo-home-link">
      <img src={SITE.logo} alt="Eclipsia" className={`${className} w-auto`} />
    </Link>
  </motion.div>
);
